import BranchApi from 'api/branch';
import DealerApi from 'api/dealer';
import events from 'lib/events';
import getProductDict from '../../customer/system/productDict';
import LayoutRadioGroup from 'components/forms/LayoutRadioGroup';
import LayoutSelect from 'components/forms/layoutSelect';
import Loader from 'components/loader';
import LoadingBtn from 'components/loadingBtn';
import Pool from 'models/pool';
import ProductApi from 'api/product';
import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import session from 'services/sessionService';
import WaterEnhancerApi from 'api/waterEnhancer';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {
  systemTypeNamesFormat,
  systemTypes,
  productTypes,
  poolProductTypeNamesFormat,
  spaProductTypeNamesFormat,
  swimSpaProductTypeNamesFormat,
  waterEnhancersPerSystem,
  waterEnhancersCustomSettings,
} from 'helpers/constants';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';
import { isBalanceCompleteSanitizer } from '../../../helpers/constants';

const ALL = {value: 'All', label: 'All'};

function getProductCount(branchSummaries, productCode) {
  let products = branchSummaries.filter(x => x.product === productCode);

  if (!products.length == 0) {
    return products.map(a => a.count).reduce((a, b) => a + b, 0);
  }
  return 0;
}

function getWaterEnhancerCount(branchSummaries, waterEnhancer, currentStatusSelected, replaceStatusSelected) {
  if (!(branchSummaries && currentStatusSelected !== replaceStatusSelected)) {
    return 0;
  }

  let enhancer = branchSummaries.find(x => x.enhancer === waterEnhancer);

  return currentStatusSelected ? enhancer.countEnabled : enhancer.countDisabled;
}

function getWaterEnhancerCountCustomSetting(branchSummaries, currentWaterEnhancerCode, replacementWaterEnhancerCode) {
  if (!(branchSummaries && currentWaterEnhancerCode !== replacementWaterEnhancerCode)) {
    return 0;
  }

  let enhancerValue = branchSummaries.find(x =>  !currentWaterEnhancerCode ?
    x.value === currentWaterEnhancerCode :
    x.value === currentWaterEnhancerCode.toString());

  return enhancerValue ? enhancerValue.countByValue : 0;
}

function getScalePreventionProductCount(branchSanitizerSummaries, productCode, productSanitizerWardenID) {
  const products = branchSanitizerSummaries.filter(x => 
    x.sanitizer === productSanitizerWardenID && 
    (x.product === productCode || 
      (productCode === 61 && x.product === null) // if none is selected (wardenID = 61), include scalePrevention = null count
    ));

  if (products.length > 0) {
    return products.map(a => a.count).reduce((a, b) => a + b, 0);
  }

  return 0;
}

function getProductName(names, ids, product) {
  for (let i = 0; i < ids.length; ++i) {
    if (product === ids[i]) {
      return names[i];
    }
  }
  return '';
}



class ProductUpdate extends React.PureComponent {
  static displayName = 'ProductUpdate';

  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    branchSummaries: [],
    branchSanitizerSummaries: [],
    branches: [],
    dealer: {},
    loaded: false,
    products: [],
    productType: '',
    saving: false,
    selectedBranches: [],
    systemType: 1,
    currentProduct: null,
    currentProductCode: null,
    currentWaterEnhancerStatus: null,
    replacementWaterEnhancerStatus: null,
    currentWaterEnhancerCode: null,
    replacementWaterEnhancerCode: null,
    replacementProduct: null,
    systemProductTypes: poolProductTypeNamesFormat(this.props.intl.formatMessage),
    currentWaterEnhancer: null,
    isWaterEnhancerProduct: false,
    customEnhancerSetting: null,
    isBalanceCompleteProduct: false,
    currentBalanceComplete: null,
    currentBalanceCompleteStatus: false,
    isScalePreventionProduct: false,
    currentScalePreventionSanitizer: null, 
    currentScalePreventionSanitizerWardenID: null,
  };

  componentWillMount() {
    const {formatMessage} = this.props.intl;

    this.fetchData();

    ALL.label = formatMessage({id: 'general.all'});
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }


  fetchData = () => {
    let apis = [];

    apis.push(BranchApi.getFullBranches());
    apis.push(ProductApi.getProducts());
    apis.push(DealerApi.getDealer(session.getUser().dealerId));

    Promise.all(apis)
      .then(([branches, products, dealer]) => {
        let selectedBranches = [];

        if (branches.length === 1) {
          selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
        }
        this.setState({
          branches,
          dealer,
          loaded: true,
          products,
          selectedBranches,
        });
      });
  };

  switchBranch = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      this.setState({
        branchSummaries: [],
        branchSanitizerSummaries: [],
        currentProduct: null,
        currentProductCode: null,
        productType: '',
        currentWaterEnhancerStatus: null,
        replacementWaterEnhancerStatus: null,
        currentWaterEnhancerCode: null,
        replacementWaterEnhancerCode: null,
        replacementProduct: null,
        selectedBranches: [],
        systemType: 1,
        systemProductTypes: poolProductTypeNamesFormat(this.props.intl.formatMessage),
        currentWaterEnhancer: null,
        isWaterEnhancerProduct: false,
        isBalanceCompleteProduct: false,
        customEnhancerSetting: null,
        currentBalanceComplete: null,
        currentBalanceCompleteStatus: false,
        isScalePreventionProduct: false,
        currentScalePreventionSanitizer: null, 
        currentScalePreventionSanitizerWardenID: null,
      });
      return;
    }
    // Ensure that 'All' cannot be selected along with other values in a multiselect
    if (Array.isArray(selectedOptions) && Array.isArray(this.state.selectedBranches)) {
      let prevIndexOfAll = this.state.selectedBranches.indexOf(ALL);
      let currentIdxOfAll = selectedOptions.indexOf(ALL);

      // If 'ALL' is being added to the selected options, then force it to be the only option selected
      if (currentIdxOfAll !== -1 && prevIndexOfAll === -1) {
        selectedOptions = [selectedOptions[currentIdxOfAll]];
        // Remove 'ALL', when the user is trying to add another option
      } else if (currentIdxOfAll !== -1 && selectedOptions.length > 1) {
        selectedOptions.splice(currentIdxOfAll, 1);
      }
    }
    this.setState({
      branchSummaries: [],
      branchSanitizerSummaries: [],
      currentProduct: null,
      currentProductCode: null,
      productType: '',
      replacementProduct: null,
      selectedBranches: selectedOptions,
      systemType: 1,
      systemProductTypes: poolProductTypeNamesFormat(this.props.intl.formatMessage),
      currentWaterEnhancerStatus: null,
      replacementWaterEnhancerStatus: null,
      currentWaterEnhancerCode: null,
      replacementWaterEnhancerCode: null,
      currentWaterEnhancer: null,
      isWaterEnhancerProduct: false,
      isBalanceCompleteProduct: false,
      customEnhancerSetting: null,
      currentBalanceComplete: null,
      currentBalanceCompleteStatus: false,
      isScalePreventionProduct: false,
      currentScalePreventionSanitizer: null,
      currentScalePreventionSanitizerWardenID: null,
    });
  };

  switchProductCategory = (e) => {
    let {formatMessage} = this.props.intl;

    if (e && e.value) {
      if (e.value !== 'waterenhancers' && e.value !== 'balancecomplete') {
        this.setState({loaded: false});
        let branchIDs = this.state.selectedBranches.map(x => x.value).join(',');

        if (branchIDs.includes(formatMessage({id: 'general.all'}))) {
          branchIDs = this.state.branches.map(x => x.id).join(',');
        }

        if (e.value === productTypes.scalePrevention){
          ProductApi.getBranchSanitizerSummaries(branchIDs, this.state.systemType, parseInt(e.value))
            .then(branchSanitizerSummaries => {
              this.setState({
                branchSummaries: [],
                branchSanitizerSummaries,
                currentProduct: null,
                currentProductCode: null,
                loaded: true,
                productType: parseInt(e.value),
                replacementProduct: null,
                currentWaterEnhancer: null,
                isWaterEnhancerProduct: false,
                currentWaterEnhancerStatus: null,
                replacementWaterEnhancerStatus: null,
                currentWaterEnhancerCode: null,
                replacementWaterEnhancerCode: null,
                customEnhancerSetting: null,
                isBalanceCompleteProduct: false,
                currentBalanceComplete: null,
                currentBalanceCompleteStatus: false,
                isScalePreventionProduct: true,
                currentScalePreventionSanitizer: null,
                currentScalePreventionSanitizerWardenID: null,
              });
            }).catch(e => {
              this.setState({loaded: true});
            });
        } else {
          ProductApi.getBranchSummaries(branchIDs, this.state.systemType, parseInt(e.value))
            .then(branchSummaries => {
              this.setState({
                branchSummaries,
                branchSanitizerSummaries: [],
                currentProduct: null,
                currentProductCode: null,
                loaded: true,
                productType: parseInt(e.value),
                replacementProduct: null,
                currentWaterEnhancer: null,
                isWaterEnhancerProduct: false,
                currentWaterEnhancerStatus: null,
                replacementWaterEnhancerStatus: null,
                currentWaterEnhancerCode: null,
                replacementWaterEnhancerCode: null,
                customEnhancerSetting: null,
                isBalanceCompleteProduct: false,
                currentBalanceComplete: null,
                currentBalanceCompleteStatus: false,
                isScalePreventionProduct: false,
                currentScalePreventionSanitizer: null,
                currentScalePreventionSanitizerWardenID: null,
              });
            }).catch(e => {
              this.setState({loaded: true});
            });
        }
      } else if (e.value === 'waterenhancers') {
        this.setState({
          loaded: true,
          currentProduct: null,
          currentProductCode: null,
          productType: e.value,
          replacementProduct: null,
          branchSummaries: [],
          branchSanitizerSummaries: [],
          currentWaterEnhancerStatus: true,
          replacementWaterEnhancerStatus: false,
          currentWaterEnhancerCode: null,
          replacementWaterEnhancerCode: null,
          isWaterEnhancerProduct: true,
          customEnhancerSetting: null,
          isBalanceCompleteProduct: false,
          currentBalanceComplete: null,
          currentBalanceCompleteStatus: false,
          isScalePreventionProduct: false,
          currentScalePreventionSanitizer: null,
          currentScalePreventionSanitizerWardenID: null,
        });
      } else if (e.value === 'balancecomplete') {
        this.setState({
          loaded: true,
          currentProduct: null,
          currentProductCode: null,
          productType: e.value,
          replacementProduct: null,
          branchSummaries: [],
          branchSanitizerSummaries: [],
          currentWaterEnhancerStatus: false,
          replacementWaterEnhancerStatus: false,
          currentWaterEnhancerCode: null,
          replacementWaterEnhancerCode: null,
          isWaterEnhancerProduct: false,
          customEnhancerSetting: null,
          isBalanceCompleteProduct: true,
          isScalePreventionProduct: false,
          currentScalePreventionSanitizer: null,
          currentScalePreventionSanitizerWardenID: null,
        });
      };
    } else {
      this.setState({
        branchSummaries: [],
        branchSanitizerSummaries: [],
        productType: e.value,
        currentProduct: null,
        currentProductCode: null,
        replacementProduct: null,
        currentWaterEnhancer: null,
        isWaterEnhancerProduct: false,
        isBalanceCompleteProduct: false,
        currentBalanceComplete: null,
        currentBalanceCompleteStatus: false,
        isScalePreventionProduct: false,
        currentScalePreventionSanitizer: null,
        currentScalePreventionSanitizerWardenID: null,
      });
    }
  };

  switchSelectedWaterEnhancer = (e) => {
    let {formatMessage} = this.props.intl;

    if (e.value) {
      this.setState({loaded: false});
      let branchIDs = this.state.selectedBranches.map(x => x.value).join(',');

      if (branchIDs.includes(formatMessage({id: 'general.all'}))) {
        branchIDs = this.state.branches.map(x => x.id).join(',');
      }

      //Check custom enhancer setting
      const customSetting = waterEnhancersCustomSettings[e.value];

      if(customSetting && customSetting.condition(this.state.dealer)) {

        WaterEnhancerApi.getBranchEnhancerSummariesCustomSetting(branchIDs, this.state.systemType, customSetting.mapTo).then(branchSummaries => {
          this.setState({
            branchSummaries,
            loaded: true,
            [e.key]: e.value,
            customEnhancerSetting: customSetting,
          });
        }).catch(e => {
          this.setState({loaded: true});
        });

      } else {
        WaterEnhancerApi.getBranchEnhancerSummaries(branchIDs, this.state.systemType, e.value).then(branchSummaries => {
          this.setState({
            branchSummaries,
            loaded: true,
            [e.key]: e.value,
            customEnhancerSetting: null,
          });
        }).catch(e => {
          this.setState({loaded: true});
        });
      }
    } else {
      this.setState({
        [e.key]: null,
      });
    }
  };

  switchWaterEnhancerStatus = (e) => {
    this.setState({
      [e.key]: e.value === 'true',
    });
  };

  switchBalanceCompleteStatus = (e) => {
    this.setState({
      [e.key]: e.value === 'true',
    });
  };

  switchWaterEnhancerCode = (e) => {
    this.setState({
      [e.key]: e.value,
    });
  };


  getProductTypeOptions = (typeID) => {
    if (typeID === systemTypes.spa) {
      return spaProductTypeNamesFormat(this.props.intl.formatMessage);
    } else if (typeID === systemTypes.swimspa) {
      return swimSpaProductTypeNamesFormat(this.props.intl.formatMessage);
    }
    return poolProductTypeNamesFormat(this.props.intl.formatMessage);
  };

  switchSystemType = (e) => {
    this.setState({
      branchSummaries: [],
      branchSanitizerSummaries: [],
      currentProduct: null,
      currentProductCode: null,
      currentWaterEnhancer: null,
      isWaterEnhancerProduct: false,
      productType: '',
      replacementProduct: null,
      systemType: parseInt(e.value),
      systemProductTypes: this.getProductTypeOptions(parseInt(e.value)),
      currentWaterEnhancerStatus: null,
      replacementWaterEnhancerStatus: null,
      currentWaterEnhancerCode: null,
      replacementWaterEnhancerCode: null,
      customEnhancerSetting: null,
      currentBalanceComplete: null,
      currentBalanceCompleteStatus: false,
      currentBalanceCompleteChanged: false,
      isScalePreventionProduct: false,
      currentScalePreventionSanitizer: null,
      currentScalePreventionSanitizerWardenID: null,
    });
  };

  updateProduct = (productsDict) => (e) => {
    let state = Object.assign({}, this.state);

    if (e.value) {
      state[e.key] = e.value;
    } else {
      state[e.key] = null;
    }

    if (e.key === 'currentProduct') {
      state.currentProductCode = e.value ? productsDict.products.find(p => p.id === e.value).wardenID : null;
    }
    else if (e.key === 'currentScalePreventionSanitizer'){
      state.currentScalePreventionSanitizerWardenID = e.value ? productsDict.products.find(p => p.id === e.value).wardenID : null;
    }
    
    this.setState(state);
  };

  cancel = () => {
    location.hash = '#tools/accounts';
  };

  submitEnabled = () => {
    let {
      saving, selectedBranches, systemType, productType, currentProduct, currentProductCode, replacementProduct, branchSummaries,
      isWaterEnhancerProduct, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus,
      customEnhancerSetting, currentWaterEnhancerCode, replacementWaterEnhancerCode, currentBalanceCompleteChanged, isScalePreventionProduct,
      currentScalePreventionSanitizer
    } = this.state;

    let productChangeCondition = currentProduct && currentProductCode && replacementProduct && currentProduct !== replacementProduct &&
      branchSummaries.length > 0 && branchSummaries.find(x => x.product === currentProductCode && !isWaterEnhancerProduct);

    let waterEnhancerChangeCondition = isWaterEnhancerProduct && !customEnhancerSetting &&
     currentWaterEnhancer && currentWaterEnhancerStatus !== replacementWaterEnhancerStatus;

    let waterEnhancerCustomSettingChangeCondition = isWaterEnhancerProduct && !!customEnhancerSetting &&
     currentWaterEnhancer && currentWaterEnhancerCode !== replacementWaterEnhancerCode;

    let scalePreventionCondition = currentProduct && currentProductCode && replacementProduct && currentProduct !== replacementProduct && isScalePreventionProduct && currentScalePreventionSanitizer;

    return !saving && selectedBranches.length && systemType && productType &&
     (productChangeCondition || waterEnhancerChangeCondition || waterEnhancerCustomSettingChangeCondition || currentBalanceCompleteChanged || scalePreventionCondition);
  };

  submit = () => {
    let {formatMessage} = this.props.intl;
    let {
      branches, selectedBranches, systemType, productType, currentProduct, currentProductCode, replacementProduct, branchSummaries,
      isWaterEnhancerProduct, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus, customEnhancerSetting,
      currentWaterEnhancerCode, replacementWaterEnhancerCode, isBalanceCompleteProduct, branchSanitizerSummaries, isScalePreventionProduct, 
      currentScalePreventionSanitizer, currentScalePreventionSanitizerWardenID
    } = this.state;

    if (this.submitEnabled()) {
      this.setState({saving: true});

      let branchIDs = selectedBranches.map(x => x.value).join(',');

      if (branchIDs.includes(formatMessage({id: 'general.all'}))) {
        branchIDs = this.state.branches.map(x => x.id).join(',');
      }
      if (!isWaterEnhancerProduct && !isBalanceCompleteProduct) {
        let num = isScalePreventionProduct ? 
        getScalePreventionProductCount(branchSanitizerSummaries, currentProductCode, currentScalePreventionSanitizerWardenID) : 
        getProductCount(branchSummaries, currentProductCode);

        let pool = new Pool({typeID: systemType});
        let {productDict} = getProductDict({pool, products: this.state.products, dealer: this.state.dealer, formatMessage, noFilter: true});
        let {keys, names} = productDict[Object.keys(productTypes).find(x => productTypes[x] === productType)];

        let {productDict: fullDict} = getProductDict({
          pool,
          products: this.state.products,
          dealer: this.state.dealer,
          prevPool: pool,
          noFilter: true,
          formatMessage,
        });
        let {names: fullNames, keys: fullKeys} = fullDict[Object.keys(productTypes).find(x => productTypes[x] === productType)];

        let currentProductName = getProductName(fullNames, fullKeys, currentProduct);
        let newProductName = getProductName(names, keys, replacementProduct);

        if (isScalePreventionProduct) {
          ProductApi
          .updateScalePreventionProducts(branchIDs, systemType, productType, currentScalePreventionSanitizer, currentProduct, replacementProduct)
          .then(() => {
            events.publish('success.user', {
              message: formatMessage({id: 'tools.update.products.successfully'}, {count: num, currentproduct: currentProductName, newproduct: newProductName}),
            });
            if (this.mounted) {
              let selectedBranches = [];

              if (branches.length === 1) {
                selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
              }

              this.setState({
                branchSummaries: [],
                branchSanitizerSummaries: [],
                productType: '',
                saving: false,
                selectedBranches,
                systemType: 1,
                currentProduct: null,
                currentProductCode: null,
                replacementProduct: null,
                currentWaterEnhancerStatus: null,
                replacementWaterEnhancerStatus: null,
                currentWaterEnhancerCode: null,
                replacementWaterEnhancerCode: null,
                currentWaterEnhancer: null,
                isWaterEnhancerProduct: false,
                customEnhancerSetting: null,
                currentBalanceComplete: null,
                currentBalanceCompleteStatus: false,
                currentBalanceCompleteChanged: false,
                isScalePreventionProduct: false,
                currentScalePreventionSanitizer: null,
                currentScalePreventionSanitizerWardenID: null,
              });
            }
          })
          .catch(err => {
            events.publish('error.user', {
              message: formatMessage({id: 'tools.update.products.failed'}, {count: num, currentproduct: currentProductName, newproduct: newProductName}),
            });
            this.setState({
              saving: false,
            });
          });
        } else {
          ProductApi
            .updateProducts(branchIDs, systemType, productType, currentProduct, replacementProduct)
            .then(() => {
              events.publish('success.user', {
                message: formatMessage({id: 'tools.update.products.successfully'}, {count: num, currentproduct: currentProductName, newproduct: newProductName}),
              });
              if (this.mounted) {
                let selectedBranches = [];
  
                if (branches.length === 1) {
                  selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
                }
  
                this.setState({
                  branchSummaries: [],
                  branchSanitizerSummaries: [],
                  productType: '',
                  saving: false,
                  selectedBranches,
                  systemType: 1,
                  currentProduct: null,
                  currentProductCode: null,
                  replacementProduct: null,
                  currentWaterEnhancerStatus: null,
                  replacementWaterEnhancerStatus: null,
                  currentWaterEnhancerCode: null,
                  replacementWaterEnhancerCode: null,
                  currentWaterEnhancer: null,
                  isWaterEnhancerProduct: false,
                  customEnhancerSetting: null,
                  currentBalanceComplete: null,
                  currentBalanceCompleteStatus: false,
                  currentBalanceCompleteChanged: false,
                  isScalePreventionProduct: false,
                  currentScalePreventionSanitizer: null,
                  currentScalePreventionSanitizerWardenID: null,
                });
              }
            })
            .catch(err => {
              events.publish('error.user', {
                message: formatMessage({id: 'tools.update.products.failed'}, {count: num, currentproduct: currentProductName, newproduct: newProductName}),
              });
            });
        }
      } else if (isBalanceCompleteProduct) {
        const pool = new Pool({typeID: this.state.systemType});
        let {productDict} = getProductDict({pool, products: this.state.products, dealer: this.state.dealer, formatMessage, noFilter: true});
        const currentSanitizer = productDict.sanitizer.products.find(product => product.id === this.state.currentBalanceComplete);
        ProductApi
        .updateBalanceComplete(branchIDs, systemType, currentSanitizer.id, this.state.currentBalanceCompleteStatus)
        .then(() => {
          events.publish('success.user', {
            message: formatMessage({id: 'tools.update.balanceComplete.successfully'} ),
          });
          if (this.mounted) {
            this.setState({
              branchSummaries: [],
              branchSanitizerSummaries: [],
              productType: '',
              saving: false,
              selectedBranches,
              systemType: 1,
              currentProduct: null,
              currentProductCode: null,
              replacementProduct: null,
              currentWaterEnhancerStatus: null,
              replacementWaterEnhancerStatus: null,
              currentWaterEnhancerCode: null,
              replacementWaterEnhancerCode: null,
              currentWaterEnhancer: null,
              isWaterEnhancerProduct: false,
              customEnhancerSetting: null,
              currentBalanceComplete: null,
              currentBalanceCompleteStatus: false,
              currentBalanceCompleteChanged: false,
              isScalePreventionProduct: false,
              currentScalePreventionSanitizer: null,
              currentScalePreventionSanitizerWardenID: null,
            });
          }
        })
        .catch(err => {
          events.publish('error.user', {
            message: formatMessage({id: 'tools.update.balanceComplete.failed'}),
          });
        });
      } else if (isWaterEnhancerProduct) {
        let num = !customEnhancerSetting ?
          getWaterEnhancerCount(branchSummaries, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus) :
          getWaterEnhancerCountCustomSetting(branchSummaries, currentWaterEnhancerCode, replacementWaterEnhancerCode);
        let waterEnhancers = waterEnhancersPerSystem(this.state.dealer, this.state.systemType, formatMessage);
        let enhancer = waterEnhancers[currentWaterEnhancer];
        let apiRequest = !customEnhancerSetting ?
          WaterEnhancerApi.updateWaterEnhancers(branchIDs, systemType, currentWaterEnhancer, currentWaterEnhancerStatus, replacementWaterEnhancerStatus) :
          WaterEnhancerApi.updateWaterEnhancersCustomSetting(branchIDs, systemType, customEnhancerSetting.mapTo, currentWaterEnhancerCode, replacementWaterEnhancerCode);

        apiRequest.then(() => {
          const messageID = !customEnhancerSetting ? 'tools.update.enhancers.successfully' : 'tools.update.customEnhancer.successfully';

          events.publish('success.user', {
            message: formatMessage({id: messageID},
              {enhancer, count: num,
                currentstatus: currentWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
                newstatus: replacementWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
              }),
          });
          if (this.mounted) {
            let selectedBranches = [];

            if (branches.length === 1) {
              selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
            }

            this.setState({
              branchSummaries: [],
              branchSanitizerSummaries: [],
              productType: '',
              saving: false,
              selectedBranches,
              systemType: 1,
              currentProduct: null,
              currentProductCode: null,
              replacementProduct: null,
              currentWaterEnhancerStatus: null,
              replacementWaterEnhancerStatus: null,
              currentWaterEnhancerCode: null,
              replacementWaterEnhancerCode: null,
              currentWaterEnhancer: null,
              isWaterEnhancerProduct: false,
              customEnhancerSetting: null,
              isBalanceCompleteProduct: false,
              currentBalanceComplete: null,
              currentBalanceCompleteStatus: false,
              currentBalanceCompleteChanged: false,
              isScalePreventionProduct: false,
              currentScalePreventionSanitizer: null,
              currentScalePreventionSanitizerWardenID: null,
            });
          }
        })
          .catch(err => {
            const messageID = !customEnhancerSetting ? 'tools.update.enhancers.failed' : 'tools.update.customEnhancer.failed';

            events.publish('error.user', {
              message: formatMessage({id: messageID},
                {enhancer, count: num,
                  currentstatus: currentWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
                  newstatus: replacementWaterEnhancerStatus ? formatMessage({id: 'tools.update.enhancer.checked'}).toLowerCase() :
                  formatMessage({id: 'tools.update.enhancer.unchecked'}).toLowerCase(),
                }),
            });
            this.setState({
              saving: false,
            });
          });
      }
    }
  };

  getStepOne = () => {
    let branchOptions = [ALL].concat(this.state.branches.map(({id, name}) => ({label: name, value: id})));
    let {formatMessage} = this.props.intl;

    return <div className='col-md-4'>
      <Step number={1}
            total={3}
            title={formatMessage({id: 'general.select.store'}) + '(s)'}>
        <div>
          {branchOptions.length > 2 ? // This should be 2 since all is included as an option
            <ReactSelect name='branches'
                         multi={true}
                         options={branchOptions}
                         value={this.state.selectedBranches}
                         placeholder={this.props.intl.formatMessage({id: 'general.select.store'})}
                         onChange={this.switchBranch}/> :
            this.state.selectedBranches.length > 0 ? this.state.selectedBranches[0].label : null
          }
        </div>
      </Step>
    </div>;
  };

  getStepTwo = () => {
    let {formatMessage} = this.props.intl;

    if (!this.state.selectedBranches.length) {
      return null;
    }

    let systemProductTypes = this.getProductTypeOptions(this.state.systemType);
    let productTypeKeys = Object.keys(systemProductTypes);
    let productTypeOptions = Object.values(systemProductTypes);

    //Default empty option
    productTypeKeys.unshift('');
    productTypeOptions.unshift(formatMessage({id: 'tools.update.select.type'}));
    //Water Enhancer option
    productTypeKeys.push('waterenhancers');
    productTypeOptions.push(formatMessage({id: 'chemicals.water.enhancers'}));
    //Balance Complete Option
    productTypeKeys.push('balancecomplete');
    productTypeOptions.push(formatMessage({id: 'chemicals.water.balanceComplete'}));

    const systemTypeNames = systemTypeNamesFormat(formatMessage);
    let systemTypeKeys = Object.keys(systemTypeNames).map(x => parseInt(x));
    let systemTypeOptions = Object.values(systemTypeNames);

    return <div className='col-md-4'>
      <Step number={2}
            total={3}
            title={formatMessage({id: 'tools.update.system.product'})}>
        <div>
          <LayoutRadioGroup label={formatMessage({id: 'general.system.type'})}
                            options={systemTypeOptions}
                            dataKey='systemType'
                            inline={true}
                            colSizes={[4, 3, 5]}
                            value={this.state.systemType}
                            keys={systemTypeKeys}
                            onChange={this.switchSystemType}/>
          <LayoutSelect label={formatMessage({id: 'general.product.category'})}
                        editMode={true}
                        keys={productTypeKeys}
                        options={productTypeOptions}
                        dataKey='productType'
                        dataChanged={this.switchProductCategory}
                        value={this.state.productType}/>
        </div>
      </Step>
    </div>;
  };

  getStepThree = () => {
    if (this.state.isWaterEnhancerProduct) {
      return this.getStepThreeWaterEnhancers();
    }
    if (this.state.isBalanceCompleteProduct) {
      return this.getStepThreeBalanceComplete();
    }
    if (this.state.isScalePreventionProduct) {
      return this.getStepThreeScalePrevention();
    }
    return this.getStepThreeProductDetails();
  };

  getStepThreeProductDetails = () => {
    let {formatMessage} = this.props.intl;

    if (!this.state.productType || !this.state.systemType) {
      return null;
    }

    const pool = new Pool({typeID: this.state.systemType});
    let {productDict: fullDict} = getProductDict({
      pool,
      products: this.state.products,
      dealer: this.state.dealer,
      prevPool: pool,
      noFilter: false,
      formatMessage,
      onlyCustomFilter: p => !(p.code === '42665' && p.country === 'CA') // Hide Chlorinating Tabs in ALEX CA
    });

    let {productDict} = getProductDict({
      pool,
      products: this.state.products,
      dealer: this.state.dealer,
      formatMessage,
      noFilter: false,
      onlyCustomFilter: p => !(p.code === '42665' && p.country === 'CA') // Hide Chlorinating Tabs in ALEX CA
    });

    let prodType = Object.keys(productTypes).find(x => productTypes[x] === this.state.productType);
    let {names, keys} = productDict[prodType];
    let {names: fullNames, keys: fullKeys} = fullDict[prodType];

    if (names.length === 0) {
      names.push('n/a');
      keys.push('');
    } else {
      names.unshift(formatMessage({id: 'tools.update.select.product'}));
      keys.unshift('');
    }

    if (fullNames.length === 0) {
      fullNames.push('n/a');
      fullKeys.push('');
    } else {
      fullNames.unshift(formatMessage({id: 'tools.update.select.product'}));
      fullKeys.unshift('');
    }

    return <div className='col-md-4'>
      <Step number={3}
            total={3}
            title={formatMessage({id: 'tools.update.switch.recommended'})}>
        <div>
          <LayoutSelect label={formatMessage({id: 'tools.update.current.product'})}
                        options={fullNames}
                        keys={fullKeys}
                        value={this.state.currentProduct || ''}
                        dataKey='currentProduct'
                        dataChanged={this.updateProduct(fullDict[prodType])}
                        editMode={true}/>
          <LayoutSelect label={formatMessage({id: 'tools.replace.with'})}
                        dataKey='replacementProduct'
                        options={names}
                        keys={keys}
                        value={this.state.replacementProduct || ''}
                        dataChanged={this.updateProduct(productDict[prodType])}
                        editMode={true}/>
        </div>
      </Step>
    </div>;
  };

  getStepThreeScalePrevention = () => {
    let {formatMessage} = this.props.intl;

    if (!this.state.productType || !this.state.systemType) {
      return null;
    }

    const pool = new Pool({typeID: this.state.systemType});
    let {productDict: fullDict} = getProductDict({
      pool,
      products: this.state.products,
      dealer: this.state.dealer,
      prevPool: pool,
      noFilter: true,
      formatMessage,
    });

    let {productDict} = getProductDict({
      pool,
      products: this.state.products,
      dealer: this.state.dealer,
      formatMessage,
      noFilter: true
    });

    let {productDict: sanitizerDict} = getProductDict({
      pool,
      products: this.state.products,
      dealer: this.state.dealer,
      noFilter: true,
      formatMessage,
    });

    let sanitizerType = Object.keys(productTypes).find(x => productTypes[x] === productTypes.sanitizer);
    let prodType = Object.keys(productTypes).find(x => productTypes[x] === this.state.productType);
    
    let {names: sanitizerNames, keys: sanitizerKeys} = sanitizerDict['sanitizer'];
    let {names, keys} = productDict[prodType];
    let {names: fullNames, keys: fullKeys} = fullDict[prodType];

    // Sanitizer Product Names
    if (sanitizerNames.length === 0) {
      sanitizerNames.push('n/a');
      sanitizerKeys.push('');
    } else {
      sanitizerNames.unshift(formatMessage({id: 'tools.update.select.product'}));
      sanitizerKeys.unshift('');

      // Filter out Mineral Springs and SoftSwim B, does not apply to Scale Prevention
      const mineralSpringIndex = sanitizerNames.indexOf('Mineral Springs');
      if (mineralSpringIndex > -1){
        sanitizerNames.splice(mineralSpringIndex, 1);
        sanitizerKeys.splice(mineralSpringIndex, 1);
      }
      const softSwimBIndex = sanitizerNames.indexOf('SoftSwim B');
      if (softSwimBIndex > -1){
        sanitizerNames.splice(softSwimBIndex, 1);
        sanitizerKeys.splice(softSwimBIndex, 1);
      }

      // Hiding rdt chlorinating tabs in CA 
      const rdtChlorinatingTabs = sanitizerNames.indexOf('Rapid-Dissolve Chlorinating Tabs');
      if (rdtChlorinatingTabs > -1 && this.state.dealer.country == 'CA'){
        sanitizerNames.splice(rdtChlorinatingTabs, 1);
        sanitizerKeys.splice(rdtChlorinatingTabs, 1);
      }
    }

    // Current Product Names
    if (fullNames.length === 0) {
      fullNames.push('n/a');
      fullKeys.push('');
    } else {
      fullNames.unshift(formatMessage({id: 'tools.update.select.product'}));
      fullKeys.unshift('');

      // Don't want to show SaltScapes Scale Defender
      const saltScapesScaleDefenderIndex = fullNames.indexOf('SaltScapes Scale Defender');
      if (saltScapesScaleDefenderIndex > -1){
        fullNames.splice(saltScapesScaleDefenderIndex, 1);
        fullKeys.splice(saltScapesScaleDefenderIndex, 1);
      }

      // Hiding rdt chlorinating tabs in CA 
      const rdtChlorinatingTabs = fullNames.indexOf('Rapid-Dissolve Chlorinating Tabs');
      if (rdtChlorinatingTabs > -1 && this.state.dealer.country == 'CA'){
        fullNames.splice(rdtChlorinatingTabs, 1);
        fullKeys.splice(rdtChlorinatingTabs, 1);
      }
    }
    
    // Replacement Product Names
    if (names.length === 0) {
      names.push('n/a');
      keys.push('');
    } else {
      names.unshift(formatMessage({id: 'tools.update.select.product'}));
      keys.unshift('');
      
      // Don't want to show SaltScapes Scale Defender
      const saltScapesScaleDefenderIndex = names.indexOf('SaltScapes Scale Defender');
      if (saltScapesScaleDefenderIndex > -1){
        names.splice(saltScapesScaleDefenderIndex, 1);
        keys.splice(saltScapesScaleDefenderIndex, 1);
      }

      // Hiding rdt chlorinating tabs in CA 
      const rdtChlorinatingTabs = names.indexOf('Rapid-Dissolve Chlorinating Tabs');
      if (rdtChlorinatingTabs > -1 && this.state.dealer.country == 'CA'){
        names.splice(rdtChlorinatingTabs, 1);
        keys.splice(rdtChlorinatingTabs, 1);
      }
    }

    return <div className='col-md-4'>
      <Step number={3}
            total={3}
            title={formatMessage({id: 'tools.update.switch.recommended'})}>
        <div>
          <LayoutSelect 
                        label={formatMessage({id: 'tools.update.current.sanitizer'})}
                        options={sanitizerNames}
                        keys={sanitizerKeys}
                        value={this.state.currentScalePreventionSanitizer || ''}
                        dataKey='currentScalePreventionSanitizer'
                        dataChanged={this.updateProduct(sanitizerDict[sanitizerType])}
                        editMode={true}/>
          <LayoutSelect label={formatMessage({id: 'tools.update.current.product'})}
                        options={fullNames}
                        keys={fullKeys}
                        value={this.state.currentProduct || ''}
                        dataKey='currentProduct'
                        dataChanged={this.updateProduct(fullDict[prodType])}
                        editMode={true}/>
          <LayoutSelect label={formatMessage({id: 'tools.replace.with'})}
                        dataKey='replacementProduct'
                        options={names}
                        keys={keys}
                        value={this.state.replacementProduct || ''}
                        dataChanged={this.updateProduct(productDict[prodType])}
                        editMode={true}/>
        </div>
      </Step>
    </div>;
  };

  getStepThreeWaterEnhancers = () => {
    if (!this.state.systemType) {
      return null;
    }
    let {formatMessage} = this.props.intl;
    let waterEnhancers =   waterEnhancersPerSystem(this.state.dealer, this.state.systemType, this.props.intl.formatMessage);
    let fullKeys =  Object.keys(waterEnhancers);
    let fullNames =  Object.values(waterEnhancers);

    if (fullNames.length === 0) {
      fullNames.push('n/a');
      fullKeys.push('');
    } else {
      fullNames.unshift(formatMessage({id: 'tools.update.select.product'}));
      fullKeys.unshift('');
    }

    return <div className='col-md-4'>
      <Step number={3}
            total={3}
            title={formatMessage({id: 'tools.update.switch.enhancer'})}>
        <div>
          <LayoutSelect label={formatMessage({id: 'tools.update.select.enhancer'})}
                        options={fullNames}
                        keys={fullKeys}
                        value={this.state.currentWaterEnhancer}
                        dataKey='currentWaterEnhancer'
                        dataChanged={this.switchSelectedWaterEnhancer}
                        editMode={true}/>
          {this.getWaterEnhancerConfiguration()}
        </div>
      </Step>
    </div>;
  };

  getWaterEnhancerConfiguration = () => {
    let {formatMessage} = this.props.intl;
    let waterEnhancerStatus = {
      names: [formatMessage({id: 'tools.update.enhancer.checked'}), formatMessage({id: 'tools.update.enhancer.unchecked'})],
      keys: ['true', 'false'],
    };
    const defaultWaterEnhancerSetting = <React.Fragment>
      <LayoutRadioGroup label={formatMessage({id: 'tools.update.current.status'})}
                  options={waterEnhancerStatus.names}
                  dataKey='currentWaterEnhancerStatus'
                  groupName='currentWaterEnhancerStatus'
                  inline={true}
                  value={this.state.currentWaterEnhancerStatus.toString()}
                  keys={waterEnhancerStatus.keys}
                  onChange={this.switchWaterEnhancerStatus}/>
      <LayoutRadioGroup label={formatMessage({id: 'tools.update.replace.status'})}
                  options={waterEnhancerStatus.names}
                  dataKey='replacementWaterEnhancerStatus'
                  groupName='replacementWaterEnhancerStatus'
                  inline={true}
                  value={this.state.replacementWaterEnhancerStatus.toString()}
                  keys={waterEnhancerStatus.keys}
                  onChange={this.switchWaterEnhancerStatus}/>
    </React.Fragment>;

    // Disable by  https://biolabinc.atlassian.net/browse/ALEX-2745
    // switch(this.state.currentWaterEnhancer) {
    //   case waterEnhancersCustomSettings.usingOptimizerPlus.key:
    //     if(waterEnhancersCustomSettings.usingOptimizerPlus.condition(this.state.dealer)) {
    //       const keys = [optimizerProducts.optimizer, optimizerProducts.optimizerPlus, ''];
    //       const options = [formatMessage({id: 'general.optimizer'}), formatMessage({id: 'general.optimizer.plus'}), formatMessage({id: 'general.none'})];

    //       return <React.Fragment>
    //         <LayoutSelect label={formatMessage({id: 'tools.update.current.product'})}
    //                     options={options}
    //                     keys={keys}
    //                     value={this.state.currentWaterEnhancerCode}
    //                     dataKey='currentWaterEnhancerCode'
    //                     dataChanged={this.switchWaterEnhancerCode}
    //                     editMode={true}/>
    //         <LayoutSelect label={formatMessage({id: 'tools.replace.with'})}
    //                     dataKey='replacementWaterEnhancerCode'
    //                     options={options}
    //                     keys={keys}
    //                     value={this.state.replacementWaterEnhancerCode}
    //                     dataChanged={this.switchWaterEnhancerCode}
    //                     editMode={true}/>
    //       </React.Fragment>;
    //     }
    //     return defaultWaterEnhancerSetting;
    //   default:
    //     return defaultWaterEnhancerSetting;
    // }

    return defaultWaterEnhancerSetting;
  }

  switchSelectedBalanceComplete = (e) => {
    let {formatMessage} = this.props.intl;

    if (e.value) {
      this.setState({loaded: false});
      this.setState({
        [e.key]: e.value,
        currentBalanceCompleteStatus: false,
        currentBalanceCompleteChanged: true,
        loaded: true,
      });

    } else {
      this.setState({
        [e.key]: null,
        currentBalanceCompleteStatus: false,
        currentBalanceCompleteChanged: false,
      });
    }
  };

  getStepThreeBalanceComplete = () => {
    let {formatMessage} = this.props.intl;

    if (!this.state.productType || !this.state.systemType) {
      return null;
    }

    const pool = new Pool({typeID: this.state.systemType});
    let {productDict} = getProductDict({pool, products: this.state.products, dealer: this.state.dealer, formatMessage, noFilter: true});
    const sanitizers = productDict.sanitizer.products.filter(product => isBalanceCompleteSanitizer(product.name));
    let fullKeys =  sanitizers.map(sanitizer => sanitizer.id);
    let fullNames =  sanitizers.map(sanitizer => sanitizer.name);

    if (fullNames.length === 0) {
      fullNames.push('n/a');
      fullKeys.push('');
    } else {
      fullNames.unshift(formatMessage({id: 'tools.update.select.product'}));
      fullKeys.unshift('');
    }
    
    return <div className='col-md-4'>
      <Step number={3}
            total={3}
            title={formatMessage({id: 'tools.update.switch.recommended'})}>
        <div>
          <LayoutSelect label={formatMessage({id: 'tools.update.select.product'})}
                        options={fullNames}
                        keys={fullKeys}
                        value={this.state.currentBalanceComplete}
                        dataKey='currentBalanceComplete'
                        dataChanged={this.switchSelectedBalanceComplete}
                        editMode={true}/>
          {this.getBalanceCompleteConfiguration()}
        </div>
      </Step>
    </div>;
  };

  getBalanceCompleteConfiguration = () => {
    let {formatMessage} = this.props.intl;
    let balanceCompleteStatus = {
      names: [formatMessage({id: 'tools.update.balanceComplete.on'}), formatMessage({id: 'tools.update.balanceComplete.off'})],
      keys: ['true', 'false'],
    };
    const defaultWaterEnhancerSetting = <React.Fragment>
      <LayoutRadioGroup label={formatMessage({id: 'tools.update.replace.status'})}
                  options={balanceCompleteStatus.names}
                  dataKey='currentBalanceCompleteStatus'
                  groupName='currentBalanceCompleteStatus'
                  inline={true}
                  value={this.state.currentBalanceCompleteStatus.toString()}
                  keys={balanceCompleteStatus.keys}
                  onChange={this.switchBalanceCompleteStatus}/>
    </React.Fragment>;

    return defaultWaterEnhancerSetting;
  }

  render() {
    return <div className='product-update-tool'>
      <h2><FormattedMessage id="tools.update.product.profile"/></h2>
      <p><FormattedMessage id="tools.update.product.explanation"/></p>
      <Loader loaded={this.state.loaded}>
        <div className='col-xs-12'>
          <div className='row product-step-row'>
            {this.getStepOne()}
            {this.getStepTwo()}
            {this.getStepThree()}
          </div>
        </div>
        <div className='row'>
          {(this.state.branchSummaries && this.state.branchSummaries.length > 0 || 
            this.state.branchSanitizerSummaries && this.state.branchSanitizerSummaries.length > 0) &&
            (this.state.currentProduct && !this.state.isScalePreventionProduct || 
              this.state.currentWaterEnhancer ||
              this.state.isScalePreventionProduct && this.state.currentProduct && this.state.currentScalePreventionSanitizer
            ) ?
            <div className='col-xs-12 disclaimer'>
              <i className='bl bl-help-circle blue'/>&nbsp;&nbsp;
              <FormattedMessage id="tools.update.systems.count" values={{
                count: this.state.currentProduct ?
                  this.state.isScalePreventionProduct ?
                  getScalePreventionProductCount(this.state.branchSanitizerSummaries, this.state.currentProductCode, this.state.currentScalePreventionSanitizerWardenID) :
                  getProductCount(this.state.branchSummaries, this.state.currentProductCode) :
                  !!this.state.customEnhancerSetting ?
                    getWaterEnhancerCountCustomSetting(this.state.branchSummaries, this.state.currentWaterEnhancerCode, this.state.replacementWaterEnhancerCode) :
                    getWaterEnhancerCount(this.state.branchSummaries, this.state.currentWaterEnhancer,
                    this.state.currentWaterEnhancerStatus, this.state.replacementWaterEnhancerStatus
              )}}/>
              <span className='blue semi-bold'> <FormattedMessage id="tools.update.cannot.undone"/></span>
            </div> : null}
          <div className='col-xs-12'>
            <div className='pull-right'>
              <button className='btn btn-default'
                      style={{marginRight: 15}}
                      onClick={this.cancel}><FormattedMessage id="general.cancel"/></button>
              <LoadingBtn className='btn btn-primary'
                          onClick={this.submit}
                          disabled={!this.submitEnabled()}
                          loading={this.state.saving}><FormattedMessage id="general.update"/></LoadingBtn>
            </div>
          </div>
        </div>
      </Loader>
    </div>;
  }
}

class Step extends React.PureComponent {
  static displayName = 'Step';

  static propTypes = {
    children: PropTypes.element.isRequired,
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
  };

  render() {
    return <div className='product-update-step'>
      <p className='step-label'>
        <FormattedMessage id='general.step.range'
                          values={{
                            n: this.props.number,
                            total: this.props.total,
                          }} />
      </p>
      <h3>{this.props.title}</h3>
      {this.props.children}
    </div>;
  }
}

export default bindLocaleUpdate(injectIntl(ProductUpdate));
